import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_PORTFOLIOS = 'GET_PORTFOLIOS';

// Largest portfolios first unless the page asks for another order.
const DEFAULT_ORDERING = '-market_value';

const apiCall = createApiCall(GET_PORTFOLIOS, (params: { ordering?: string }) => ({
  endpoint: generateEndpoint({
    host: '/api/admin/portfolios',
    params: { ...params, ordering: params.ordering || DEFAULT_ORDERING },
  }),
  method: 'GET',
}));

export default apiCall;
